import { render, staticRenderFns } from "./ed-register-account-info.component.vue?vue&type=template&id=f19dd16e&scoped=true&"
import script from "./ed-register-account-info.component.ts?vue&type=script&lang=ts&"
export * from "./ed-register-account-info.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-register-account-info.component.scss?vue&type=style&index=0&id=f19dd16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19dd16e",
  null
  
)

export default component.exports